export enum scoreLabels {
    DARTLEGLABEL = 'L',
}
